import RouteLink from './RouteLink'

interface SiteFooterProps {
  onNavigate: (path: string) => void
}

const footerColumns = [
  {
    title: 'Platform',
    items: [
      { label: 'Platform Overview', path: '/platform' },
      { label: 'Governance & OCAP', path: '/solutions/governance-ocap' },
      { label: 'Infrastructure', path: '/solutions/infrastructure' },
      { label: 'AI & Future Readiness', path: '/solutions/ai-future-readiness' },
    ],
  },
  {
    title: 'Trust',
    items: [
      { label: 'OCAP', path: '/ocap' },
      { label: 'AI Readiness', path: '/ai-readiness' },
      { label: 'Security & Trust', path: '/security-trust' },
      { label: 'Case Studies', path: '/case-studies' },
      { label: 'Resources', path: '/resources' },
    ],
  },
  {
    title: 'Company',
    items: [
      { label: 'About', path: '/about' },
      { label: 'Bios', path: '/bios' },
      { label: 'Contact', path: '/contact' },
    ],
  },
]

export default function SiteFooter({ onNavigate }: SiteFooterProps) {
  return (
    <footer className="border-t border-white/10 bg-charcoal/90">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr]">
          <div className="max-w-xl">
            <p className="font-display text-3xl tracking-tight text-birch">
              Yethirihwanonhase
            </p>
            <p className="mt-5 text-base leading-7 text-weathered">
              Indigenous-owned digital infrastructure and advisory leadership focused on
              sovereignty, governance, and responsible AI readiness.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <RouteLink href="/contact" onNavigate={onNavigate} className="btn-primary">
                Book a Consultation
              </RouteLink>
              <RouteLink href="/resources" onNavigate={onNavigate} className="btn-secondary">
                Explore Resources
              </RouteLink>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <p className="text-sm font-semibold uppercase tracking-[0.22em] text-copper-light">
                {column.title}
              </p>
              <div className="mt-5 space-y-4">
                {column.items.map((item) => (
                  <RouteLink
                    key={item.path}
                    href={item.path}
                    onNavigate={onNavigate}
                    className="block text-sm text-weathered transition hover:text-birch"
                  >
                    {item.label}
                  </RouteLink>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-6 text-sm text-weathered md:flex-row md:items-center md:justify-between">
          <p>© 2026 Yethirihwanonhase. Indigenous-owned. All rights reserved.</p>
          <p>Our Land. Our Data. Our Network.</p>
        </div>
      </div>
    </footer>
  )
}
